import { getInsFromPatient, remoteFormats } from "./index";

export const extractOpenDmp = (data) => {
  const {
          addAccessAuthorization: {
            value: addAccessAuthorization
          } = {}
        }   = data;
  const ins = getInsFromPatient(data, remoteFormats.XML);
  
  return {
    addAccessAuthorization: [true, "true", "1", 1].includes(addAccessAuthorization),
    ...ins
  };
};

export const extractJSONOpenDmp = (data) => {
  const {
          addAccessAuthorization
        }   = data;
  const ins = getInsFromPatient(data, remoteFormats.JSON);
  
  return { addAccessAuthorization, ...ins };
};